import ApexChartContainer from "../../components/charts/apexChart";

const ApexChart = () => {
  return <ApexChartContainer />;
};

export default ApexChart;
